<template>
    <div class='SavedBuildTab text-center' :class="[ { 'active': myProduct.route == currNav } ]">
        <a href='' @click.prevent='displayItem'>
            <span>{{myProduct.name}}</span>
        </a>
        <a class='closebt' href='' @click.prevent='removeItem'>
            <span>x</span>
        </a>
    </div>
</template>

<script>
    export default {
        name:'SavedBuildTabs',
        props:['product'],
        data(){
            return {
                myProduct: this.$props.product,
                currNav:  this.$route.path
            }
        },
        methods:{
            displayItem(){
                this.$router.push(this.$props.product.route)
            },
            removeItem(e){
                console.log('close: '+ this.myProduct.name);
                this.$store.dispatch('ProductCollection/removeForm', this.myProduct.name);
            }
        }
    }
</script>